import { NumberFormatter } from "./NumberFormatter";

import CurrencyHandler from "@/components/widgets/CurrencyHandler/CurrencyHandler";
import ThemeSwitcher from "@/components/widgets/ThemeHandler/ThemeSwitcher";

export const SettingsList = () => {
  return (
    <>
      <ThemeSwitcher />
      <CurrencyHandler />
      <NumberFormatter />
    </>
  );
};
